import type {
  PaginatedEvent,
  QueryEventsArgs,
} from '@tribeplatform/gql-client/types'

import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
} from '../../lib/react-query/useInfiniteQuery.js'
import { useTribeClient } from '../../useTribeClient.js'

import { getEventsListKey } from './event.key.js'

export const useSearchEventForEmbed = (options: {
  variables: QueryEventsArgs
  useInfiniteQueryOptions?: UseInfiniteQueryOptions<PaginatedEvent>
}) => {
  const { variables, useInfiniteQueryOptions } = options || {}
  const { client } = useTribeClient()
  const eventsListKey = getEventsListKey({ variables })

  return useInfiniteQuery<PaginatedEvent>(
    eventsListKey,
    ({ pageParam: after }) => client.events.list({ after, ...variables }),
    {
      ...useInfiniteQueryOptions,
    },
  )
}
